var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"partners"}},[_c('div',{staticClass:"col-md-4 col-sm-5 mt-3 p-2 pl-4 titleBlock"},[_vm._v("\r\n            "+_vm._s(_vm.header)+"\r\n        ")]),_vm._v(" "),_c('ul',_vm._l((_vm.partners),function(pt,index){return _c('li',{key:index},[_c('a',{attrs:{"href":pt.url}},[_c('img',{attrs:{"src":pt.image.src}})])])}))])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6f36cbc7","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/overall_layouts/partners.vue
// module id = 590
// module chunks = 0